import React from 'react'

export default function Badge({bgColor = '#91d3ff', data}) {
  return (
    <p className="inline m-0 py-1 px-2 text-xs drop-shadow-md font-bold" style={{backgroundColor: bgColor, borderRadius: "15px"  }}>
        {data}
    </p>
  )
}
